import { api } from "@/lib/api";
import { createAppointmentPhotos } from "@/lib/appointment-photos";

export const AppointmentPhotoRepository = createAppointmentPhotos(api.appointments, (url, init) => fetch(url, init));
